interface Props {
   photo?: string
   name: string
   size?: "sm" | "md" | "lg" | "xl"
   editable?: boolean
   onPhotoChange?: (file: File) => void
}

const sizes = {
   sm: "w-10",
   md: "w-16",
   lg: "w-24",
   xl: "w-32",
}

export function UserAvatar({ photo, name, size = "md", editable, onPhotoChange }: Props) {
   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      event.stopPropagation()
      const file = event.target.files?.[0]
      if (file && onPhotoChange) {
         onPhotoChange(file)
      }
   }

   return (
      <div className={`relative group ${sizes[size]} ${sizes[size].replace("w", "h")}`}>
         {photo ? (
            <div className={`avatar`}>
               <div className={`rounded-full ${sizes[size]} ${sizes[size].replace("w", "h")}`}>
                  <img src={photo} loading="lazy" />
               </div>
            </div>
         ) : (
            <div className="avatar placeholder">
               <div
                  className={`bg-base-200 text-neutral-content rounded-full ${sizes[size]} ${sizes[
                     size
                  ].replace("w", "h")}`}
               >
                  <span className="text-xl">{name[0]}</span>
               </div>
            </div>
         )}

         {editable && (
            <label
               className={`absolute ${
                  size === "xl" && "h-[128px]"
               } inset-0 flex items-center justify-center bg-black bg-opacity-80 rounded-full opacity-60 group-hover:opacity-100 cursor-pointer transition-opacity`}
               htmlFor="photo-upload"
            >
               <svg
                  className="h-8 w-8 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
               >
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth={3}
                     d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                  />
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth={2}
                     d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                  />
               </svg>
               <input
                  id="photo-upload"
                  type="file"
                  className="hidden"
                  accept="image/*"
                  onChange={handleFileChange}
               />
            </label>
         )}
      </div>
   )
}
